/**
 * @param {*} input 
 * @returns {number} the number of json objects found
 * Hm - might be more useful to return the json objects directly?
 */
export function extractAndCountJsonObjects(input) {
    // console.log("Input => ",input);
    const results = [];

    let depth = 0; // To monitor how far inside the json object we are. depth=0 (outside {}), depth=1(opened a { ), depth=2 (opened a nested { inside of parent { )
    let start = -1; // To monitor the starting point of our json object.
    let inString = false;
    let escape = false;

    for (let i = 0; i < input.length; i++) {
        const ch = input[i];

        if (inString) {
        /*
            This if-block is placed to avoid few patterns discovered during traversing the test string.
            - If the last letter was \, then ignore the next one (escape = true).
            - If see another " and not escaped, the string ends (inString = false).
            - While in a string, don’t care about { or }, so skip them with continue.
        */
        if (escape) {
            escape = false; // skip escaped char
        } else if (ch === "\\") {
            escape = true;
        } else if (ch === '"') {
            inString = false;
        }
        continue;
        }

        if (ch === '"') {
            inString = true;
        } else if (ch === "{") {
        if (depth === 0) start = i; //Bascially meaning this is a new JSON object discovered, therefore wwe also mark start = i, to specify that okay at this point in the string we found a json object.
            depth++; // For any future nested json objects inside the current json object found.
        } else if (ch === "}") {
            if (depth > 0) { // Meaning a json object closed.
                depth--; // If it was nested we go one depth level up.
                if (depth === 0 && start !== -1) {
                const candidate = input.slice(start, i + 1); // Basically cutting out the part that is json inside the string.
                try {
                    const parsed = JSON.parse(candidate); // Rectify whether the json is valid or not.
                    results.push({ json: parsed, text: candidate, start, end: i + 1 }); // If valid, found 1. Add it to the list.
                } catch (err) {
                    // ignore if not valid JSON
                }
                start = -1;
                }
            }
        }
    }

    return results.length;
}